import React from "react";
import calendar from "../../assets/images/calandar2262.svg";
import location from "../../assets/images/location2269.svg";
import check from "../../assets/images/check2258.svg";
import textweb from "../../assets/images/textweb.png";
import "./text.css";
import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../constants/endpoints";
const RSVPCardData = ({data}) => {

  return (
    <div className="rsvp-main">
      <h1
        className="mb-2 text-[18px] text-[#4F2532]"
        style={{ fontFamily: "bold" }}
      >
        {data?.data.event_name}
      </h1>

      <h1 className="text-[12px] mil-icn" style={{ fontFamily: "thin" }}>
        <img
          src={calendar}
          alt="Calendar Icon"
          className=" left-[-3px] mr-2 card-icon"
        />{""}
        <span className="pl-[2px] card-text text-[#4F2532]">
        {data?.data.event_date}, {" "}{data?.data.event_start_time}
        </span>
      </h1>

      {/* Location icon and text */}
      <h1 className="text-[12px] mil-icn" style={{ fontFamily: "thin" }}>
        <img
          src={location}
          alt="Location Icon"
          className=" left-[-3px] mr-2 card-icon"
        />{" "}
        {/* Added margin-right */}
        <span className="pl-[2px] card-text address text-[#4F2532]">
          {data?.data?.venue_name}
        </span>
      </h1>
      {/* <div className="tag-main">
        <div className="tag-btn" style={{ fontFamily: "thin" }}>
          <img src={check} className="" />
          {data?.data?.schedule.split(",")[0]}
        </div>
        <div className="tag-btn" style={{ fontFamily: "thin" }}>
          <img src={check} className="" />
          {data?.data?.schedule.split(",")[1]}
        </div>
      </div> */}
    </div>
  );
};

export default RSVPCardData;
